import { useEffect, useState } from 'react';

function StatusMessage({ loading = false, error = '', success = '', onRetry }) {
  const [visibleSuccess, setVisibleSuccess] = useState('');

  useEffect(() => {
    if (!success) {
      setVisibleSuccess('');
      return;
    }

    setVisibleSuccess(success);

    const timerId = window.setTimeout(() => {
      setVisibleSuccess('');
    }, 2000);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [success]);

  if (!loading && !error && !visibleSuccess) {
    return null;
  }

  return (
    <div className="mt-4 space-y-2">
      {loading ? (
        <p className="font-login text-[13px] text-[#5f6673]">Guardando...</p>
      ) : null}

      {error ? (
        <div className="flex flex-wrap items-center gap-3">
          <p className="font-login text-[13px] text-[#c43c2f]">{error}</p>
          {onRetry ? (
            <button
              type="button"
              onClick={onRetry}
              className="rounded-[8px] border border-[#c43c2f] px-3 py-1 font-login text-[12px] font-semibold text-[#c43c2f] transition hover:bg-[#fff3f1]"
            >
              Reintentar
            </button>
          ) : null}
        </div>
      ) : null}

      {visibleSuccess ? (
        <p className="font-login text-[13px] text-[#1d9657]">{visibleSuccess}</p>
      ) : null}
    </div>
  );
}

export default StatusMessage;
